/* ==========================================================================
   VEDIUM theme — vanilla JS (no dependencies)
   - header, mobile menu, scroll reveal
   - cart drawer (server-rendered through the Section Rendering API)
   - product form (variant picker, price, availability, gallery sync)
   - size guide modal, collection filters, account helpers
   ========================================================================== */
(function () {
  'use strict';

  var VED = window.VED || {};
  var routes = VED.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = formatString.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- scroll reveal ---------- */
  var io = null;
  function reveal() {
    var items = $$('.rv:not(.in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- cart drawer ---------- */
  function drawer() { return $('[data-drawer]'); }

  function openCart() {
    var d = drawer();
    if (!d) return;
    document.body.classList.add('cart-open');
    d.setAttribute('aria-hidden', 'false');
    var close = $('[data-cart-close]', d);
    if (close) close.focus({ preventScroll: true });
  }

  function closeCart() {
    var d = drawer();
    document.body.classList.remove('cart-open');
    if (d) d.setAttribute('aria-hidden', 'true');
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function refreshDrawer() {
    var d = drawer();
    if (!d) return Promise.resolve();
    d.classList.add('is-loading');
    var sep = routes.cart.indexOf('?') > -1 ? '&' : '?';
    return fetch(routes.cart + sep + 'section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = $('[data-drawer-content]', doc);
        var current = $('[data-drawer-content]', d);
        if (next && current) {
          current.replaceWith(next);
          setCount(next.getAttribute('data-count') || 0);
        }
      })
      .catch(function () { /* keep the current drawer */ })
      .then(function () { d.classList.remove('is-loading'); });
  }

  function changeLine(key, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshDrawer(); });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) {
        if (document.body.classList.contains('template-cart') || !drawer()) return;
        e.preventDefault();
        refreshDrawer().then(openCart);
        return;
      }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-veil]')) {
        closeCart();
        return;
      }
      var qty = e.target.closest('[data-qty-change]');
      if (qty) {
        e.preventDefault();
        changeLine(qty.getAttribute('data-key'), parseInt(qty.getAttribute('data-qty'), 10) || 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeCart(); closeModals(); }
    });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-menu-toggle]');
      if (!toggle) return;
      var nav = $('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }

  /* ---------- modals (size guide) ---------- */
  function closeModals() {
    $$('[data-modal].open').forEach(function (m) {
      m.classList.remove('open');
      m.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('modal-open');
  }

  function initModals() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-modal-open]');
      if (openBtn) {
        var m = document.getElementById(openBtn.getAttribute('data-modal-open'));
        if (m) {
          m.classList.add('open');
          m.setAttribute('aria-hidden', 'false');
          document.body.classList.add('modal-open');
        }
        return;
      }
      if (e.target.closest('[data-modal-close]') || (e.target.matches && e.target.matches('[data-modal]'))) {
        closeModals();
      }
    });
  }

  /* ---------- product form ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    if (!variants || !variants.length) return;

    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var priceEl = $('[data-price-current]', section);
    var compareEl = $('[data-price-compare]', section);
    var gallery = $('[data-gallery]', section);
    var dots = $$('[data-dots] i', section);
    var fieldsets = $$('[data-option-index]', section);

    var currentId = idInput ? parseInt(idInput.value, 10) : variants[0].id;
    var current = variants.filter(function (v) { return v.id === currentId; })[0] || variants[0];
    var selected = (current.options || []).slice();

    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }

    function update(fromClick) {
      var variant = findVariant(selected);
      if (!variant) {
        /* combination does not exist: fall back to the first variant that has the last clicked value */
        variant = variants.filter(function (v) { return v.options.indexOf(fromClick) > -1; })[0] || variants[0];
        selected = variant.options.slice();
      }
      current = variant;

      if (idInput) { idInput.value = variant.id; idInput.disabled = !variant.available; }
      if (priceEl) priceEl.textContent = formatMoney(variant.price, VED.moneyFormat);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price, VED.moneyFormat);
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }

      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        $$('[data-option-value]', fs).forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var on = selected[idx] === val;
          btn.classList.toggle('on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          var probe = selected.slice();
          probe[idx] = val;
          var match = findVariant(probe);
          btn.classList.toggle('soldout', !match || !match.available);
        });
      });

      /* keep the URL shareable */
      if (window.history && history.replaceState && section.getAttribute('data-product-url')) {
        history.replaceState({}, '', section.getAttribute('data-product-url') + '?variant=' + variant.id);
      }

      /* jump to the variant image */
      if (gallery && variant.featured_media && variant.featured_media.id) {
        var target = $('[data-media-id="' + variant.featured_media.id + '"]', gallery);
        if (target) scrollToMedia(gallery, target);
      }
    }

    function scrollToMedia(gal, item) {
      var isCarousel = getComputedStyle(gal).display === 'flex';
      if (isCarousel) {
        gal.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else {
        var y = item.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn || !section.contains(btn)) return;
      var fs = btn.closest('[data-option-index]');
      var idx = parseInt(fs.getAttribute('data-option-index'), 10);
      selected[idx] = btn.getAttribute('data-option-value');
      update(selected[idx]);
    });

    /* gallery dots (mobile swipe) */
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
    }

    /* add to cart */
    var form = $('[data-product-form]', section);
    if (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name !== 'add') return; /* express checkout buttons handle themselves */
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;

        var errorEl = $('[data-form-error]', form);
        if (errorEl) errorEl.textContent = '';
        addBtn.disabled = true;

        var data = new FormData(form);
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorEl) errorEl.textContent = res.json.description || res.json.message || 'Could not add this item.';
              return;
            }
            return refreshDrawer().then(openCart);
          })
          .catch(function () { form.submit(); })
          .then(function () { addBtn.disabled = !current.available; });
      });
    }

    update();
  }

  /* ---------- collection filters ---------- */
  function initFacets() {
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facets]');
      if (form) form.submit();
    });
  }

  /* ---------- account helpers ---------- */
  function initAccount() {
    var login = $('[data-login-view]');
    var recover = $('[data-recover-view]');
    if (login && recover) {
      var show = function (rec) { login.hidden = rec; recover.hidden = !rec; };
      if (window.location.hash === '#recover' || $('.form-msg', recover)) show(true);
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-recover-toggle]');
        if (!t) return;
        e.preventDefault();
        show(login.hidden === false);
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-toggle-target]');
      if (toggle) {
        var el = document.getElementById(toggle.getAttribute('data-toggle-target'));
        if (el) el.hidden = !el.hidden;
        return;
      }
      var del = e.target.closest('[data-delete-address]');
      if (del) {
        if (!window.confirm('Delete this address?')) return;
        var tokenInput = $('input[name="authenticity_token"]');
        var f = document.createElement('form');
        f.method = 'post';
        f.action = del.getAttribute('data-delete-address');
        f.innerHTML = '<input type="hidden" name="_method" value="delete">' +
          (tokenInput ? '<input type="hidden" name="authenticity_token" value="' + tokenInput.value + '">' : '');
        document.body.appendChild(f);
        f.submit();
      }
    });
  }

  /* ---------- boot ---------- */
  function initSections(root) {
    $$('[data-section-type="product"]', root).forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMenu();
    initModals();
    initCart();
    initFacets();
    initAccount();
    initSections(document);
    reveal();
  });

  /* theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    initSections(e.target);
    reveal();
  });

  window.VED = VED;
  window.VED.formatMoney = formatMoney;
})();
